import { Component } from "react";
import { compose } from "redux";
import { termsConnector } from "../../../services/terms/connector";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import LenderTerms from "./Terms.Lender.Component";
import GeneralTerms from "./Terms.Savelend.General.Component";
import PaymentServiceTerms from "./Terms.PaymentService.Component";

class SavelendTerms extends Component {
  constructor(props) {
    super(props);
    this.state = { slideIndex: 0 };
  }

  handleChange = (event, newValue) => {
    this.setState({
      slideIndex: newValue,
    });
  };

  render() {
    return (
      <div className="terms-layout body-height">
        <Tabs onChange={this.handleChange} value={this.state.slideIndex}>
          <Tab label="Lender terms" value={0} />
          <Tab label="General terms" value={1} />
          <Tab label="Payment Service terms" value={2} />
        </Tabs>
        {this.state.slideIndex === 0 && (
          <div className="content-padding">
            <LenderTerms {...this.props} />
          </div>
        )}{" "}
        {this.state.slideIndex === 1 && (
          <div className="content-padding">
            <GeneralTerms {...this.props} />
          </div>
        )}
        {this.state.slideIndex === 2 && (
          <div className="content-padding">
            <PaymentServiceTerms {...this.props} />
          </div>
        )}
      </div>
    );
  }
}
export default compose(termsConnector)(SavelendTerms);
